¬
<template>
	<div class="aside">
		<div class="menus-box">
			<div class="menus">
				<div v-for="(item,index) in routes" :key="index" class="menus-item level-1">
					<router-link v-if="item.children" :to="getPath(item)" class="menus-item-link v-row v-center" exact active-class="active">
						<i class="menus-item-icon iconfont" :class="item.children[0].meta.icon"></i> <span class="menus-item-txt">{{ item.children[0].meta.title }}</span>
					</router-link>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import routes from '@/router/router'

	export default {
		data() {
			return {
				config: this.config,
				info: {},
				isShowModifyLogo: false
			};
		},
		computed: {
			routes() {
				return routes.filter(item => !item.hidden);
			},
		

		},

		methods: {
			getPath(row){
				let path = '';
				path = row.path !== '/' ? row.path + '/' : row.path;
				path += row.children[0].path;
				return path
			},
		}
	};
</script>

<style lang="scss" scoped>
	.store-name {
		width: 100%;
		text-align: center;
		padding: 0 30px;
		box-sizing: border-box;
		height: 24px;
	}

	.aside {
		background: #001236;
		border-radius: 4px;
		overflow: hidden;
		color: #ffffff;
		font-size: 14px;
		display: flex;
		flex-direction: column;
		width: 180px;
	}

	.menus-box {
		flex: 1;
		min-height: 0;
		width: 100%;
		overflow: hidden;
	}

	.menus {
		height: 100%;
		overflow-y: auto;
		padding-right: 20px;
		width: 100%;

		.menus-item {
			cursor: pointer;
			width: 180px;
		}

		.menus-item-icon {
			margin-right: 12px;
			width: 18px;
			font-size: 15px;
		}

		.menus-item-arrow {
			font-size: 12px;
			transition: transform 0.3s ease;

			&.active {
				transform: rotate(180deg);
			}
		}

		.menus-item-txt {
			flex: 1;
		}

		.menus-item-link,
		.menus-item-title {
			height: 60px;
			padding: 0 22px 0 26px;
			color: #fff;
			text-decoration: none;
			opacity: 0.9;

			&:hover,
			&.active {
				color: #4e81ff;
				opacity: 1;
			}
		}

		.level-1 .menus-item-link:hover,
		.level-1 .menus-item-link.active {
			background: #4e81ff;
			color: #fff;
		}

		.level-2 .menus-item-title:hover,
		.level-2 .menus-item-title.active {
			background: #4e81ff;
			color: #fff;
		}

		.level-2 .menus-item-link {
			background: #000205;
		}

		.menus-item-submenu {
			height: 0;
			overflow: hidden;
			transition: height 0.3s ease;
		}
	}
</style>
